import fetch from "isomorphic-fetch";
import queryString from "query-string";
import UAParser from "ua-parser-js";
import { getRandomFilename } from "./utils";

class Tracker {
  constructor() {
    this.$config = {
      baseUrl: "https://t.bukalapak.com",
      dev: false,
      platform: "desktop",
    };

    this._generateUAData();
    this._getUserIdentity();
  }

  _doRequest(url, data) {
    if (Array.isArray(data)) {
      data = data.map((val) => Object.assign({}, val, this.$uaData));
    } else {
      data = Object.assign({}, data, this.$uaData);
    }

    if (this.$userIdentity) {
      data.identity = this.$userIdentity;
    }

    const fetchConfig = {
      method: "POST",
      body: JSON.stringify(data),
    };

    if (!this.$config.dev) {
      fetchConfig.headers = {
        Env: "production",
      };
    }

    return fetch(url, fetchConfig);
  }

  _generateUAData() {
    if (window && window.navigator && window.navigator.userAgent) {
      const uap = new UAParser(window.navigator.userAgent);
      const uaData = {
        browser: uap.getBrowser().name,
        browser_version: uap.getBrowser().version,
        td_os_type: uap.getOS().name,
        td_os_ver: uap.getOS().version,
        platform: this.$config.platform,
      };
      this.$uaData = uaData;
    } else {
      this.$uaData = {};
    }
  }

  _getUserIdentity() {
    if (window && window.USER && document) {
      try {
        this.$userIdentity =
          (window.USER && window.USER.identity) ||
          document.cookie.match(/identity=(.*)/)[1].split(/;/)[0];
      } catch (error) {
        console.warn(error);
      }
    }
  }

  config(obj) {
    this.$config = Object.assign({}, this.$config, obj);

    if (obj.platform && obj.platform !== this.$uaData.platform) {
      this._generateUAData();
    }
  }

  event(data) {
    const url = `${this.$config.baseUrl}/e`;
    return this._doRequest(url, data);
  }

  eventBulk(data) {
    const url = `${this.$config.baseUrl}/es`;
    return this._doRequest(url, data);
  }

  pixel(data = {}, filename) {
    const { baseUrl } = this.$config;
    let qs = queryString.stringify(data);

    if (!this.$config.dev) {
      qs = `env=production&${qs}`;
    }

    return `${baseUrl}/p/${
      filename ? filename : getRandomFilename()
    }.gif?${qs}`;
  }
}

export default new Tracker();
